<router-outlet></router-outlet>
<app-modal (close)="highPriorityNotification = null" [isNotification]="true" *ngIf="highPriorityNotification">
  <div class="modal_container black-text" style="letter-spacing: initial">
    <!-- <h5 class="text-header-modal" translate>Notification</h5> -->
    <div class="modal-body">
      <h5 style="font-weight: bold;" class="mb-3" *ngIf="notificationContent?.headLine">{{notificationContent.headLine}}
      </h5>
      <p style="font-size: 1rem;" *ngIf="highPriorityNotification.contentType === 'string'">
        {{notificationContent?.content}}</p>
      <img class="img-fluid" *ngIf="['image', 'gif'].includes(highPriorityNotification.contentType)"
        [src]="notificationContent?.content" />

      <video *ngIf="highPriorityNotification.contentType === 'video'" width="400" class="w-100" controls autoplay muted>
        <source [src]="notificationContent.content" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</app-modal>